module.exports = __webpack_public_path__ + "prj_10.32080293.jpeg";